import { makeEnvironmentProviders } from '@angular/core';
import { ApiConfiguration } from '@app/infrastructure/api/api-configuration';
import { environment } from '@src/environments/environment';

export function provideApi() {
  return makeEnvironmentProviders([
    {
      provide: ApiConfiguration,
      useFactory: () => {
        const config = new ApiConfiguration();
        config.rootUrl = environment.backendUrl;
        return config;
      },
    },
  ]);
}
